import React, { createContext, useContext } from 'react';
import LoginController from '../controller/LoginController';
import { APP_TYPE } from '../utils/DataType';
import AsyncLocalStorage from '../utils/AsyncLocalStorage';
import { useNavigate } from 'react-router-dom';

type Props = {
  children: React.ReactNode;
  ref: any;
};
export const AuthContext = createContext<any>(null);
export const AuthProvider = React.forwardRef(({ children }: any, oRef: any) => {
  const [token, setToken] = React.useState('');
  const [refreshToken, setRefreshToken] = React.useState('');
  const [userInfo, setUserInfo] = React.useState<any>();
  const [isLoggedIn, setIsLoggedIn] = React.useState<any>('');
  const oNavigate = useNavigate();

  const handleLogin = async (
    sId: string,
    sPassword: string,
    bSaveId: boolean,
    bSavePw: boolean,
    sUrl?: string,
  ) => {
    let oRes = await LoginController.signIn({
      id: sId.toString(),
      password: sPassword.toString(),
      device_uuid: '',
      app_type: APP_TYPE.WEB,
      version: null,
    });
    if (oRes.data && oRes.data.ok === false) {
      return oRes.data;
    }

    if (oRes.data && oRes.data.ok === true) {
      let oUserData = oRes.data.data;
      setToken(oUserData.token);
      setRefreshToken(oUserData.refresh_token);
      setUserInfo(oUserData);
      AsyncLocalStorage.setItem('userToken', oUserData.token);
      AsyncLocalStorage.setItem('userRefreshToken', oUserData.refresh_token);
      AsyncLocalStorage.setItem('userData', JSON.stringify(oUserData));
      if (bSaveId === true) {
        AsyncLocalStorage.setItem('savedId', sId);
        AsyncLocalStorage.setItem('savedIdCheck', bSaveId.toString());
      }
      if (bSavePw === true) {
        AsyncLocalStorage.setItem('savedPassword', sPassword.toString());
        AsyncLocalStorage.setItem('savedPasswordCheck', bSavePw.toString());
      }

      if (sUrl) {
        oNavigate(sUrl);
        let oWindow: any = window;
        if (oWindow.ReactNativeWebView) {
          oWindow.ReactNativeWebView.postMessage(JSON.stringify({ loading: 'finished' }));
        }
      }
    }
  };

  const handleLogout = () => {
    setUserInfo(null);
    AsyncLocalStorage.setItem('userData', '');
    AsyncLocalStorage.setItem('userToken', '');
    AsyncLocalStorage.setItem('userRefreshToken', '');
  };

  const value = {
    token,
    refreshToken,
    userInfo,
    handleLogin: handleLogin,
    handleLogout: handleLogout,
  };

  const init = async () => {
    let sToken: string = await AsyncLocalStorage.getItem('userToken');
    let sRefreshToken: string = await AsyncLocalStorage.getItem('userRefreshToken');
    let oUserData: any = await AsyncLocalStorage.getItem('userData');

    setToken(sToken);
    setRefreshToken(sRefreshToken);
    setUserInfo(oUserData);

    if (sToken && sRefreshToken && oUserData) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  };

  let bTryLogin = false;
  const loginFromOtherDevice = async (oData: any) => {
    try {
      const loginData = JSON.parse(oData);
      if (loginData) {
        await AsyncLocalStorage.setItem('viewingFromPosKiosk', 'true');
        handleLogin(loginData.id, loginData.password, false, false, loginData.url);
      }
    } catch (err) {
      //alert(err)
    }
  };

  React.useImperativeHandle(oRef, () => ({
    _refLogout() {
      console.log('logout!!!!!!');
      handleLogout();
    },
  }));

  React.useEffect(() => {
    init();
  }, []);

  React.useEffect(() => {
    document.addEventListener('message', function WebViewListener(oEvent: any) {
      try {
        if (oEvent && oEvent.data && bTryLogin === false) {
          loginFromOtherDevice(oEvent.data);
          bTryLogin = true;
        }
      } catch (err) {
        //alert(err)
      }
    });
  }, []);

  if (isLoggedIn === '') {
    return <></>;
  }

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
});
